<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="{ hasError: !!message }">
    <slot></slot>
    <span
      v-if="message"
      class="help-block text-danger"
      v-html="message"
    >
    </span>
  </div>
</template>

<script>
import { errorsToMessage } from '../../libs/errors';
/*
- modelValue es el valor del campo que estamos monitorizando el error
- error: Es el error devuelto por el servidor

Cuando cambia el valor se limpia el error y cuando desde fuera se
asigna un error, se vuelve a mostrar
*/
export default {
  props: {
    modelValue: { type: [String, Number], default: null },
    error: { type: [String, Array], default: null },
  },
  data() {
    return {
      message: null,
    };
  },
  watch: {
    // Cuando cambia el valor quitamos el error
    modelValue() {
      this.message = null;
    },
    error() {
      this.message = errorsToMessage(this.error);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../assets/stylesheets/cifra/vars/main.scss";

  .hasError {
    :deep() {
      .form-control{
        border-color: $color-danger;
      }
      label {
        color: $color-danger;
      }
    }
  }
</style>
